import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
import { QUOTE_MESSAGE_SHORT } from '../utils/contact';
export function FinalCTA() {
  return <section className="relative overflow-hidden border-y border-neon/20 bg-ink-800 py-20 lg:py-24" data-id="element-70" data-mp="c7adc3u6m4g0">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-neon/50 to-transparent" data-id="element-71" data-mp="84ns4ls0nhrs" />
      <div className="mx-auto max-w-3xl px-5 text-center lg:px-8" data-id="element-72" data-mp="h5vfw9wwp07m">
        <h2 className="text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-73" data-mp="h5ln6ekh8ey8">
          ¿Lista para darle a tu negocio una presencia digital profesional?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-mist-muted" data-id="element-74" data-mp="qw6vwutv6zuv">
          Cuéntame sobre tu proyecto y recibe una cotización personalizada según las necesidades de
          tu negocio.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-75" data-mp="zua6wx784e8f">
          <WhatsAppButton message={QUOTE_MESSAGE_SHORT} size="lg" data-id="element-76" data-mp="2c6hl0kt8o7if">
            Solicitar cotización por WhatsApp
          </WhatsAppButton>
          <a href="#contacto" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-7 py-4 text-base font-medium text-white transition-[background-color,border-color,transform] duration-200 ease-out hover:border-neon hover:bg-neon/10 hover:text-neon active:translate-y-px" data-id="element-77" data-mp="2m344b55x2qic">
            Enviar solicitud por formulario
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="34tltx0vgd5zh" />
          </a>
        </div>
      </div>
    </section>;
}